module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-HairlineItalic-e659ce9239c36750f79852aec1368b95.woff";